import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FileText, TrendingUp, CheckCircle2, Clock, MapPin } from "lucide-react";
import { statusLabel } from "@/lib/format";
const Stat = ({ label, value, icon: Icon, hint }) => (
  <div className="card-lux p-5">
    <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-[#D4AF37] mb-3">
      <Icon size={14} /> {label}
    </div>
    <div className="font-display text-4xl text-[#F5EFE0]">{value}</div>
    {hint && <div className="text-xs text-[#F5EFE0]/50 mt-1">{hint}</div>}
  </div>
);
export default function Dashboard() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/dashboard")
      .then((r) => {
        const d = r?.data;
        setData(d && typeof d === "object" && !Array.isArray(d) ? d : {});
      })
      .catch(() => setData({}));
  }, []);

  const topDestinations = Array.isArray(data?.top_destinations) ? data.top_destinations : [];
  const byStatus = data && typeof data.by_status === "object" && data.by_status !== null ? data.by_status : {};
  const maxCount = topDestinations.length > 0 ? (topDestinations[0]?.count || 1) : 1;

  return (
    <div data-testid="dashboard-page">
      <div className="mb-8">
        <div className="text-[#E8C87A] text-xs uppercase tracking-[0.35em] mb-2">Panel</div>
        <h1 className="font-display text-3xl md:text-4xl">Resumen general</h1>
        <p className="text-sm text-[#F5EFE0]/55 mt-2">Vista rápida de la actividad de tu negocio.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <Stat label="Este mes" value={data?.quotes_this_month ?? "–"} icon={TrendingUp} hint="cotizaciones nuevas" />
        <Stat label="Total" value={data?.total_quotes ?? "–"} icon={FileText} hint="histórico" />
        <Stat label="Pendientes" value={data?.new_quotes ?? "–"} icon={Clock} hint="sin contactar" />
        <Stat label="Confirmadas" value={data?.confirmed_quotes ?? "–"} icon={CheckCircle2} hint="cerradas exitosamente" />
      </div>
      <div className="grid lg:grid-cols-2 gap-5">
        <div className="card-lux p-6">
          <div className="text-xs uppercase tracking-widest text-[#D4AF37] mb-4 flex items-center gap-2"><MapPin size={13} /> Destinos más pedidos</div>
          {topDestinations.length === 0 ? (
            <div className="text-sm text-[#F5EFE0]/50">Sin datos todavía.</div>
          ) : (
            <ul className="space-y-3">
              {topDestinations.map((d) => {
                const pct = Math.max(6, ((d?.count || 0) / maxCount) * 100);
                return (
                  <li key={d?.destination || Math.random()}>
                    <div className="flex justify-between text-sm mb-1">
                      <span className="text-[#F5EFE0]">{d?.destination || "—"}</span>
                      <span className="text-[#E8C87A]">{d?.count ?? 0}</span>
                    </div>
                    <div className="h-2 bg-[#171412] rounded-full overflow-hidden">
                      <div className="h-full bg-gradient-to-r from-[#A5842B] to-[#E8C87A]" style={{ width: `${pct}%` }} />
                    </div>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
        <div className="card-lux p-6">
          <div className="text-xs uppercase tracking-widest text-[#D4AF37] mb-4">Estado de solicitudes</div>
          {!data ? (
            <div className="text-sm text-[#F5EFE0]/50">Cargando…</div>
          ) : (
            <div className="grid grid-cols-2 gap-3">
              {Object.entries(byStatus).map(([k, v]) => (
                <div key={k} className="p-4 border border-[#3A3229] rounded-lg">
                  <div className="text-xs text-[#F5EFE0]/55">{statusLabel(k)}</div>
                  <div className="font-display text-2xl text-[#F5EFE0]">{v}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
